import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CreateWalletResponse } from '@pages/dashboard/components/NewWalletModal/services/types';
import { LoadState } from '../../pages/store/types';
import { IWallet } from '../../services/client/types';
import clientSvc from '../../services/client/clientSvc';

type WalletState = LoadState<IWallet[]>;

export const initialState: WalletState = {
  error: '',
  loading: false,
  data: null,
};

const fetchWallets = createAsyncThunk(
  'fetchWallets',
  async (enterpriseId: string) => clientSvc.getWallet({ enterpriseId })
);

export const walletsSlice = createSlice({
  name: 'wallets',
  initialState,
  reducers: {
    addNewWalletDataReducer: (
      state: WalletState,
      action: PayloadAction<CreateWalletResponse>
    ) => {
      state.data?.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWallets.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.data = null;
    });
    builder.addCase(fetchWallets.fulfilled, (state, { payload: wallets }) => {
      state.loading = false;
      state.data = wallets;
      state.error = '';
    });

    builder.addCase(fetchWallets.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export const { addNewWalletDataReducer } = walletsSlice.actions;

export { fetchWallets };
export default walletsSlice.reducer;
